<template>
  <div
    class="card shadow"
    :class="type === 'dark' ? 'bg-default' : ''"
    style="position: relative"
  >
    <GStockLoader :loading="loading" />
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
          <b-form-input
            v-model="search"
            size="sm"
            class="mr-sm-2"
            placeholder="Chercher client par nom"
          ></b-form-input>
        </div>

        <div class="col text-right">
          <base-button
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            v-b-modal.modal-ajout
            >Ajouter</base-button
          >
        </div>
      </div>
    </div>

    <base-table
      class="table align-items-center"
      :class="type === 'dark' ? 'table-dark' : ''"
      :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
      tbody-classes="list"
      :data="filteredValues"
    >
      <template slot="columns">
        <th>ID</th>
        <th>Nom et Prenom</th>
        <th>Télephone</th>
        <th>Email</th>
        <th>Crédit</th>
        <th></th>
        <th></th>
      </template>

      <template slot-scope="{ row }">
        <td
          class="budget"
          style="cursor: pointer"
          @click="$router.push({ name: 'addproduct', params: { id: row.id } })"
        >
          {{ row.id }}
        </td>
        <td
          class="budget"
          style="cursor: pointer"
          @click="$router.push({ name: 'addproduct', params: { id: row.id } })"
        >
          {{ row.fullname }}
        </td>

        <td
          style="cursor: pointer"
          @click="$router.push({ name: 'addproduct', params: { id: row.id } })"
        >
          {{ row.phonenumber }}
        </td>
        <td
          style="cursor: pointer"
          @click="$router.push({ name: 'addproduct', params: { id: row.id } })"
        >
          {{ row.email }}
        </td>
        <td
          style="cursor: pointer"
          @click="$router.push({ name: 'addproduct', params: { id: row.id } })"
        >
          {{ row.credit }} DT
        </td>

        <td style="display: flex; justify-content: center; align-items: center">
          <b-button size="sm" @click="openInNewTab(row)" class="mr-2"
            >Afficher les articles</b-button
          >
          <b-button size="sm" class="mr-2" @click="printBill(row)"
            >Imprimer contrat</b-button
          >
          <b-button
            size="sm"
            class="mr-2"
            @click="$router.push({ name: 'caisse', params: { id: row.id } })"
            >Passer à la caisse</b-button
          >
        </td>

        <td class="text-right">
          <base-dropdown class="dropdown" position="right">
            <a
              slot="title"
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>

            <template>
              <a
                class="dropdown-item"
                @click="openPopup(row)"
                href="#"
                v-b-modal.modal-center
                >Modifier</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click="openPopup(row)"
                v-b-modal.modal-1
                >Supprimer</a
              >
            </template>
          </base-dropdown>
        </td>
      </template>
    </base-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <div>
      <ModalUpdateClient
        ref="clientsmodalupdate"
        @clientsadd="clientsadd"
      ></ModalUpdateClient>
      <ModalAjoutClient @clientsadd="clientsadd"></ModalAjoutClient>
      <ModalDeleteClient
        ref="clientsmodaldelete"
        @clientsadd="clientsadd"
      ></ModalDeleteClient>
    </div>
    <div id="printable-client-bill" v-show="printing">
      <ClientBill
        :clientName="client.fullname"
        :products="client.products"
        :clientId="client.id"
        :clientPhoneNumber="client.phonenumber"
      />
    </div>
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import modal from "@/components/Modal";
import ModalUpdateClient from "./ModalUpdateClient";
import ModalAjoutClient from "./ModalAjoutClient";
import ModalDeleteClient from "./ModalDeleteClient";
import { setToken, get } from "@/mixins/api";
import ClientBill from "@/components/ClientBill";
import printJS from "print-js";
export default {
  name: "ClientTable",
  components: {
    modal,
    ModalUpdateClient,
    ModalAjoutClient,
    ModalDeleteClient,
    GStockLoader,
    ClientBill,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      modaldelete: false,
      search: "",
      tableData: [],
      data: {
        result: [],
        count: 0,
      },
      values: [],
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk",
      client: {},
      loading: false,
      printing: false,
    };
  },
  computed: {
    rows() {
      return this.tableData.filter((key) => {
        return (
          key.fullname.toLowerCase().includes(this.search.toLowerCase()) ||
          key.id == this.search ||
          key.phonenumber.includes(this.search)
        );
      }).length;
    },
    filteredValues: function () {
      return this.tableData
        .filter((key) => {
          return (
            key.fullname.toLowerCase().includes(this.search.toLowerCase()) ||
            key.id == this.search ||
            key.phonenumber.includes(this.search)
          );
        })
        .slice(
          (this.currentPage - 1) * this.perPage,
          (this.currentPage - 1) * this.perPage + this.perPage
        );
    },
  },
  methods: {
    openInNewTab(row) {
      let routeData = this.$router.resolve({
        name: "products",
        params: { id: row.id },
      });
      window.open(routeData.href, "_blank");
    },
    printBill(client) {
      this.client = client;
      this.loading = true;
      get("myproducts/" + client.id)
        .then((result) => {
          const products = result.data.deposed;
          this.client.products = products;
          this.printing = true;
          setTimeout(() => {
            printJS({
              printable: "printable-client-bill",
              type: "html",
              header: "",
            });
            this.printing = false;
          }, 500);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clientsadd(element) {
      this.getclients();
    },
    getclients() {
      this.loading = true;
      get("clients").then((response) => {
        this.tableData = response.data.data;
        this.loading = false;
      });
    },
    openPopup(data) {
      this.$refs.clientsmodalupdate.getClient(data);
      this.$refs.clientsmodaldelete.getClient(data);
    },
  },
  mounted() {
    //setToken(this.userToken);
    this.getclients();
  },
};
</script>
<style>
#printable-client-bill {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
</style>
